<template>
  <div class="app-modal-addHC-body">
    <PageLoading v-if="loading" />
    <div v-else class="content-wrapper">
      <div class="input-basic-custom">
        <label>{{ $t('actionModal.type_list_unmanaged_hc') }}</label>

         <v-select
          v-model="selectedType"
          :items="uniqueTypes"
          label="Select a type"
          single-line
         >
         </v-select>

        <label>{{ $t('actionModal.serial_list_unmanaged_hc') }}</label>
        <v-autocomplete v-if="selectedType !== ''"
          v-model="selectedAircraft"
          :items="filteredHc"
          item-text="displayValue" 
          item-value="hc" 
          return-object
          clearable
          @change="handleSelection"
          multiple
          chips
          small-chips
          single-line
          label="Select an aircraft"
        >
          <template v-slot:selection="{ item, index }">
              <v-chip v-if="index <= 6">
                <span class="autocomplete_selection_cls">{{ item.displayValue }}</span>
              </v-chip>
              <span
                v-if="index === 7"
                class="grey--text text-caption autocomplete_selection_cls"
              >
                {{ plusNothers(selectedAircraft.length - 7) }}
              </span>
          </template>
        </v-autocomplete>
        <div v-else class="input-basic inline">
          <input type="text" disabled />
        </div>
      </div>

      <div class="footer-wrapper">
        <a @click="closeModal()" class="button btn cancel-clean">{{ $t('global.button_cancel') }}</a>
        <button 
          class="button btn validationBtn" 
          :disabled="disabled"
          @click="getModalUpload()">
          {{ $t('global.button_add_hc') }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import PageLoading from '../../views/PageLoading'
import bus from '../../event/bus'

export default {
  components: {
    PageLoading
  },
  mounted () {
    this.loadUnmanagedHc()
  },
  data () {
    return {
      unmanagedHc: [],
      disabled: true,
      loading: true,
      searchQuery: '',
      selectedType: "",
      selectedAircraft: []
    }
  },
  computed: {
    sortedUnmanagedHc() {
      function compare(a, b) {
        if (a.serial.toLowerCase() < b.serial.toLowerCase()) return -1;
        if (a.serial.toLowerCase() > b.serial.toLowerCase()) return 1;
        return 0;
      }
      return this.unmanagedHc.sort(compare);
    },
    uniqueTypes() {
      const unique_types = new Set(this.unmanagedHc.map(hc => hc.display_type));
      const sorted_types = [...unique_types].sort((a, b) => a.localeCompare(b));
      return sorted_types;
    },
    filteredHc() {
      if (!this.selectedType || this.selectedType === '') return [];
      return this.sortedUnmanagedHc
        .filter(hc =>
          hc.display_type === this.selectedType &&
          (hc.serial.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
          hc.registration.toLowerCase().includes(this.searchQuery.toLowerCase()))
        )
        .map(hc => ({
          ...hc,
          displayValue: `${hc.serial} / ${hc.registration}` // Add a displayValue property
        }));
    },
  },
  methods: {
    ...mapActions('appStore', ['closeModal']),
    getModalUpload() {
      let selectedHelicopers = this.selectedAircraft.map(h => {
        return {
          serial: h.serial,
          type: h.type
        }
      });

      this.$requester
        .post('/helicopters', { selected_helicopters: selectedHelicopers })
        .then(response => {
          const responseData = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

          this.closeModal();
          bus.$emit('refreshDashboardEvt', 'Aircraft successfully added');
        })
        .catch(error => {
          console.log(error);
        });
    },

    loadUnmanagedHc() {
      this.$requester
        .get('/helicopters', { params: { managed: false } })
        .then(response => {
          const responseData = typeof response.data === 'string' ? JSON.parse(response.data) : response.data;

          responseData.fleets.forEach(fleet =>
            fleet.aircrafts.forEach(hc => this.unmanagedHc.push(hc))
          );
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    },
    changeList () {
      if (this.selectedAircraft.length > 0) {
        this.disabled = false;
      }
      else {
        this.disabled = true;
      }
    },
    handleSelection(value) {
      this.selectedAircraft = value;
      // Run changeList method
      this.changeList();
    },
    plusNothers(n) {
      if (n == 1) {
        return "(+1 other)";
      }
      else {
        return `(+${n} others)`;
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.app-modal-addHC-body {
  display: flex;
  flex-direction: column;
  overflow-y: visible;
  .content-wrapper {
    margin-top: 0;
    margin-right: 10%;
    margin-bottom: 0;
    margin-left: 10%;
  }
  .input-basic-custom {
    $blue-lynch: #647491;
    
    display: grid;
    margin-bottom: 20px;
    label {
      font-size: 15px;
      color: $blue-lynch;
      margin-bottom: 5px;
      margin-top: 20px;
      font-weight: normal;
    }
    input {
      height: 35px;
      font-size: 14px;
      &.reg-num {
        border: 1px solid #0082d5;
      }
    }
  }

  .footer-wrapper {
    margin-top: 50px;
  }

  .input-basic {
    input:disabled {
      border: none;
      background-color: rgba(154, 164, 183, 0.2);
    }
  }
}

.autocomplete_selection_cls {
  font-size: 12px
}

</style>
